import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { Clock } from 'lucide-react'

interface HourlyHeatmapProps {
  data: number[] | undefined
  isLoading: boolean
}

export function HourlyHeatmap({ data, isLoading }: HourlyHeatmapProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="h-5 w-5" />
          When People Search
        </CardTitle>
        <CardDescription>Searches by hour of day (store timezone)</CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <Skeleton className="h-24 w-full" />
        ) : !data || data.every((v) => v === 0) ? (
          <div className="flex h-24 items-center justify-center text-sm text-muted-foreground">
            No data yet
          </div>
        ) : (
          <Heatmap data={data} />
        )}
      </CardContent>
    </Card>
  )
}

function Heatmap({ data }: { data: number[] }) {
  const max = Math.max(1, ...data)

  return (
    <div>
      <div className="flex gap-[2px]">
        {data.map((count, hour) => {
          const intensity = count / max
          const bg =
            intensity === 0
              ? 'bg-muted'
              : intensity < 0.25
                ? 'bg-primary/20'
                : intensity < 0.5
                  ? 'bg-primary/40'
                  : intensity < 0.75
                    ? 'bg-primary/60'
                    : 'bg-primary'
          return (
            <div
              key={hour}
              className={`group relative flex-1 ${bg} h-10 rounded-sm transition-opacity hover:opacity-75`}
              title={`${hour.toString().padStart(2, '0')}:00 — ${count} searches`}
            >
              <span className="invisible absolute -top-7 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-foreground px-1.5 py-0.5 text-[10px] text-background group-hover:visible">
                {hour.toString().padStart(2, '0')}:00 · {count}
              </span>
            </div>
          )
        })}
      </div>
      <div className="mt-2 flex justify-between text-[10px] text-muted-foreground">
        <span>00:00</span>
        <span>06:00</span>
        <span>12:00</span>
        <span>18:00</span>
        <span>23:00</span>
      </div>
    </div>
  )
}
